import { MapPin, CreditCard, FileBarChart } from "lucide-react"

const steps = [
  {
    icon: MapPin,
    title: "Identify Your Parcel",
    description: "Search by area name, drop a pin on the map, or enter GPS coordinates to select your land parcel.",
  },
  {
    icon: CreditCard,
    title: "Select Your Package",
    description: "Choose Basic for essential risk checks or Pro for comprehensive analysis including valuation and environmental data.",
  },
  {
    icon: FileBarChart,
    title: "Get Your Report",
    description: "Receive an instant risk dashboard covering flood, legal, valuation, environmental, and slope assessments.",
  },
]

export function HowItWorks() {
  return (
    <section id="how-it-works" className="border-b border-border py-20">
      <div className="mx-auto max-w-7xl px-4 lg:px-8">
        <div className="text-center">
          <h2 className="text-balance text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            How It Works
          </h2>
          <p className="mt-3 text-pretty text-muted-foreground">
            Three simple steps to a comprehensive land risk assessment
          </p>
        </div>

        <div className="mt-14 flex flex-col items-stretch gap-8 md:flex-row">
          {steps.map((step, index) => (
            <div
              key={step.title}
              className="group relative flex flex-1 flex-col items-center rounded-xl border border-border bg-card p-8 text-center transition-shadow hover:shadow-md"
            >
              <div className="absolute -top-4 left-6 flex size-8 items-center justify-center rounded-full bg-primary text-xs font-bold text-primary-foreground">
                {index + 1}
              </div>
              <div className="flex size-14 items-center justify-center rounded-xl bg-primary/10 text-primary">
                <step.icon className="size-7" />
              </div>
              <h3 className="mt-5 text-lg font-semibold text-foreground">
                {step.title}
              </h3>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
